import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { withTheme } from "styled-components";
import HomeGrid from "@fdr/home";
// @ts-ignore
import HomeGridLegacy from "@fdr/home/src/legacy";
import { Containers } from "@fdr/static-ui/BaseComponents";
import Welcome from "@fdr/atomic-ui/_templates/Welcome";
import { TransitionState } from "@tvg/ts-types/Modal";
import { Device } from "@tvg/ts-types/Device";

// @ts-ignore
import perf from "../utils/perf";
// @ts-ignore
import { HomepageHeader } from "./HomepageHeader";

export interface Props {
  transitionState: TransitionState;
  device: Device;
}

export interface MappedState {
  welcomeLabelLoggedOut?: string;
  welcomeTitleLoggedOut?: string;
  enableNewDerbyDesign: boolean;
  enableHomepageImprovement: boolean;
}

const Home = (
  props: Props = {
    transitionState: "exit",
    device: Device.MOBILE
  }
) => {
  const { transitionState, device } = props;
  const welcomeLabelLoggedOut = useSelector((store) =>
    get(store, "capi.messages.WelcomeLabelLoggedOut")
  );
  const welcomeTitleLoggedOut = useSelector((store) =>
    get(store, "capi.messages.WelcomeTitleLoggedOut")
  );
  const enableNewDerbyDesign = useSelector((store) =>
    get(store, "capi.featureToggles.enableNewDerbyDesign", false)
  );
  const enableHomepageImprovement = useSelector((store) =>
    get(store, "capi.featureToggles.enableHomepageImprovement", false)
  );

  useEffect(() => {
    perf.measure("page_render", { page: "home" });
  }, [JSON.stringify(props)]);

  const shouldUpdate = transitionState === "entered";

  return (
    <Containers.Page enableNewDerbyDesign={enableNewDerbyDesign}>
      {enableNewDerbyDesign ? (
        <HomepageHeader />
      ) : (
        <Welcome label={welcomeLabelLoggedOut} title={welcomeTitleLoggedOut} />
      )}
      {enableHomepageImprovement ? (
        <HomeGrid shouldUpdate={shouldUpdate} device={device} />
      ) : (
        <HomeGridLegacy shouldUpdate={shouldUpdate} device={device} />
      )}
    </Containers.Page>
  );
};

// @ts-ignore
export default withTheme(Home);
